import { HttpTransport } from '@estee/elc-http-transport';

import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/OffersService';
import { IRpcPostBody, IPGResponse, IPGTokenResponse } from './IRpcAPI';

const httpTransport = new HttpTransport();

const requiredHeaders = {
    'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'x-vulcan-proxy': true
};

const getUrl = () => {
    const config = diContainer.get(serviceNames.config);
    const siteUrl =
        config?.config?.siteUrl || `${window.location.protocol}//${window.location.host}`;

    return `${siteUrl}/rpc/jsonrpc.tmpl`;
};

export const fetchToken = () => {
    const body = new URLSearchParams();
    body.append('JSONRPC', JSON.stringify([{ method: 'csrf.getToken', params: [{}] }]));

    return httpTransport
        .post({ headers: requiredHeaders, url: `${getUrl()}?dgbmethod=csrf.getToken`, body })
        .then(({ data }) => (data as IPGResponse<IPGTokenResponse>[])[0]?.result?.value?.token);
};

export const getTokenFromCookie = () => {
    const regex = new RegExp('(^| )csrftoken=([^;]+)');
    const match = document.cookie.match(regex);

    return match ? decodeURIComponent(match[2]) : '';
};

export const getToken = () => {
    const csrfToken = getTokenFromCookie();

    return csrfToken !== '' ? csrfToken : fetchToken();
};

export const makeRPCPost = async <T>(rpcBody: IRpcPostBody[], token: string = '') => {
    const [{ method = '' }] = rpcBody;
    const url = method ? `${getUrl()}?dgbmethod=${method}` : getUrl();
    const body = new URLSearchParams();
    body.append('JSONRPC', JSON.stringify(rpcBody));

    return httpTransport.post<IPGResponse<T>[]>({
        url,
        body,
        headers: {
            ...requiredHeaders,
            'x-csrf-token': token || (await getToken())
        }
    });
};
